import {
  AboutYou,
  AboutYouValidate,
  AboutYouValues,
  ContentStrengths,
  ContentStrengthsValidate,
  ContentStrengthsValues,
  Experience,
  ExperienceValidate,
  ExperienceValues,
  ThemesAndAffinities,
  ThemesAndAffinitiesValidate,
  ThemesAndAffinitiesValues,
} from '~/components/MediaPackSteps';
import { StepperFormStepType } from '~/components/StepperForm/StepperForm.types';
import { getMainPlatformData } from '~/creatorUtils';
import { CreatorType, DefaultMediaPackType } from '~/types';

interface Props {
  creator: CreatorType;
  mediaPack: DefaultMediaPackType;
}

export const STEPS = ({ creator, mediaPack }: Props): StepperFormStepType[] => {
  const { handle, name } = getMainPlatformData(creator);

  const aboutYouStep: StepperFormStepType<AboutYouValues> = {
    component: AboutYou,
    initialValues: {
      aboutMeName: mediaPack.aboutMeName || name || handle || '',
      aboutMeDescription: mediaPack.aboutMeDescription || '',
    },
    onValidate: AboutYouValidate,
    title: 'About you',
  };
  const themesAndAffinitiesStep: StepperFormStepType<ThemesAndAffinitiesValues> =
    {
      component: ThemesAndAffinities,
      initialValues: {
        themesAndAffinities: mediaPack.themesAndAffinities || [],
      },
      onValidate: ThemesAndAffinitiesValidate,
      title: 'Themes & Affinities',
    };
  const contentStrengthsStep: StepperFormStepType<ContentStrengthsValues> = {
    component: ContentStrengths,
    onValidate: ContentStrengthsValidate,
    initialValues: { contentStrengths: mediaPack.contentStrengths || [] },
    title: 'Content strengths',
  };
  const experienceStep: StepperFormStepType<ExperienceValues> = {
    component: Experience,
    onValidate: ExperienceValidate,
    initialValues: { experienceTags: mediaPack.experienceTags || [] },
    title: 'Experience',
  };
  return [
    aboutYouStep,
    themesAndAffinitiesStep,
    contentStrengthsStep,
    experienceStep,
  ];
};
